<template>
  <div role="main">
    <!--<b-row>-->
    <!--  <b-col cols="12" md="3" sm="6" class="pb-3 d-none d-md-inline">-->
    <!--    <div class="card">-->
    <!--      <div class="card-body px-3 py-2">-->
    <!--        <span class="d-block text-muted">-->
    <!--          Users Online-->
    <!--        </span>-->
    <!--        <span class="d-block font-weight-bold text-uppercase">{{ userOnline }}</span>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--  </b-col>-->

    <!--  <b-col cols="12" md="3" sm="6" class="pb-3 d-none d-md-inline">-->
    <!--    <div class="card">-->
    <!--      <div class="card-body px-3 py-2">-->
    <!--        <span class="d-block text-muted">-->
    <!--          Today-->
    <!--        </span>-->
    <!--        <span class="d-block font-weight-bold text-uppercase">-->
    <!--          ${{ counting.today }}-->
    <!--        </span>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--  </b-col>-->

    <!--  <b-col cols="12" md="3" sm="6" class="pb-3 d-none d-md-inline">-->
    <!--    <div class="card">-->
    <!--      <div class="card-body px-3 py-2">-->
    <!--        <span class="d-block text-muted">-->
    <!--          Yesterday-->
    <!--        </span>-->
    <!--        <span class="d-block font-weight-bold text-uppercase">-->
    <!--          ${{ counting.yesterday }}-->
    <!--        </span>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--  </b-col>-->

    <!--  <b-col cols="12" md="3" sm="6" class="pb-3 d-none d-md-inline">-->
    <!--    <div class="card">-->
    <!--      <div class="card-body px-3 py-2">-->
    <!--        <span class="d-block text-muted">-->
    <!--          This Week-->
    <!--        </span>-->
    <!--        <span class="d-block font-weight-bold text-uppercase">-->
    <!--          ${{ counting.thisweek }}-->
    <!--        </span>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--  </b-col>-->
    <!--</b-row>-->

    <transition appear appear-active-class="animated fadeIn faster">
      <div class="ibox" v-bind:class="{ full: fullscreen }">
        <div class="ibox-title">
          <span>
            Realtime
          </span>
          <div class="ibox-tools">
            <div role="group" arial-label="Action" class="btn-group btn-group-sm">
              <b-btn variant="secondary" v-on:click="requestData">
                <font-awesome-icon icon="sync-alt" :spin="processing" />
              </b-btn>
              <b-btn variant="secondary" v-on:click="toogleScreen">
                <font-awesome-icon v-bind:icon="fullscreen ? 'window-minimize' : 'window-maximize'"/>
              </b-btn>
            </div>
          </div>
        </div>
        <div class="ibox-content">
          <div class="table-beauty">
            <div class="table-responsive">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col" style="width: 17%;"> Date</th>
                    <th scope="col"> ID</th>
                    <th scope="col">
                      <span class="d-none d-md-inline text-nowrap"> Traffic Type</span>
                      <span class="d-inline d-md-none"> TT</span>
                    </th>
                    <th scope="col"> Country</th>
                    <th scope="col"> Payout</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="odd" v-if="processing && !table.initial">
                    <td valign="center" colspan="5" class="no-hover">
                      <div class="loading-spinner"><div class="spin">Loading...</div></div>
                    </td>
                  </tr>
                  <tr v-if="!table.rows.length && table.initial">
                    <td valign="top" colspan="5" class="no-hover text-center">No data available in table</td>
                  </tr>
                  <tr role="row" v-for="( item, index ) in table.rows" v-bind:key="index" :class="index % 2 ? 'even' : 'odd'">
                    <td class="text-nowrap">{{ item.created_at }}</td>
                    <td class="clickid-row">{{ item.click_id }}</td>
                    <td>{{ item.traffic_type }}</td>
                    <td>
                      <div class="text-nowrap" v-if="item.country instanceof Object">
                        <i class="flag-icon" v-bind:class="'flag-icon-' + item.country.iso"></i>
                        <span class="d-none d-md-inline"> {{ item.country.name }}</span>
                        <span class="d-inline d-md-none"> {{ item.country.iso | uppercase }}</span>
                      </div>
                      <div v-else>
                        {{ item.country }}
                      </div>
                    </td>
                    <td>{{ item.amt }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="table-beaury-loading" v-if="processing && table.initial"/>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  const Cookies = require( 'js-cookie' );
  const moment = require('moment');
  const axios = require('axios');
  const CancelToken = axios.CancelToken;

  export default {
    data () {
      return {
        processing: false,
        fullscreen: false,
        table: {
          initial: false,
          rows: []
        },
        sourceCancel: null
      };
    },
    computed: {
      user() {
        return this.$store.state.authentication.user
      },
      isOnwer() {
        if ( this.user.role && 'owner' === this.user.role.slug ) {
          return true
        }

        return false
      },
      userOnline() {
        return this.$store.state.user_online
      },
      counting() {
        return this.$store.state.homePage
      }
    },
    sockets: {
      new_statistic( item ) {
        if ( item.created_at ) {
          item.created_at = moment( item.created_at )
            .utcOffset( 'UTC+07:00' )
            .format( 'hh:mm:ss A' );
        }

        if ( item.amt ) {
          item.amt = '$' + item.amt.toFixed( 4 );
        }
        else {
          item.amt = '$0.0000';
        }

        if ( this.table.rows.length >= 50 ) {
          this.table.rows.splice( -1, 1 );
        }

        this.table.rows.splice( 0, 0, item );
      }
    },
    created() {
      this.requestData();
    },
    filters: {
      uppercase: value => {
        if ( !value ) {
          return '';
        }

        return value.toUpperCase();
      }
    },
    methods: {
      requestData() {
        const token = Cookies.get('__token');

        if ( this.sourceCancel ) {
          this.sourceCancel.cancel('Cancel request');
        }

        this.sourceCancel = CancelToken.source();

        const instance = axios.create( );

        instance.interceptors.request.use( config => {
          config.headers['Authorization'] = `Bearer ${token}`;
          this.processing = true;
          return config;
        }, error => {
          return Promise.reject( error );
        });

        return instance.get( `${process.env.VUE_APP_API_URL}/api/daily`, {
          cancelToken: this.sourceCancel.token
        } ).then( response => {
            const data = response.data;

            data.rows.map( item => {
              if ( item.created_at ) {
                item.created_at = moment( item.created_at )
                  .utcOffset( 'UTC+07:00' )
                  .format( 'hh:mm:ss A' );
              }

              if ( item.amt ) {
                item.amt = '$' + item.amt.toFixed( 4 );
              }
              else {
                item.amt = '$0.0000';
              }

              return item;
            } );

            this.table.rows = data.rows;

            if ( false === this.table.initial ) {
              this.table.initial = true;
            }

            this.processing = false;

            return response;
          } ).catch( error => {
            if ( false === axios.isCancel( error ) ) {
              if ( false === this.table.initial ) {
                this.table.initial = true;
              }

              this.processing = false;
            }

            if ( !error.response ) {
              // eslint-disable-next-line
              console.log( error );
              return;
            }

            const response = error.response;

            if ( response.status == 401 || response.status == 403 ) {
              this.$store.dispatch( 'authentication/logout' );
              this.$router.push('/login');
            }
          } );
      },
      toogleScreen() {
        if (this.fullscreen) {
          this.fullscreen = false;
          window.document.body.style.overflow = 'initial';
          // position: absolute;
          // top: 0;
          // left: 0;
        }
        else {
          this.fullscreen = true;
          window.document.body.style.overflow = 'hidden';
        }
      }
    },
    beforeRouteLeave( to, from, next ) {
      this.processing = true;
      next();
    }
  };
</script>
